import { Component, Output, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-user-select-checkbox',
    template: ` <input id="provider-box" type="checkbox" [checked]="value" (change)="onCheckboxChange($event)" class="form-check-input" /> `,
})
export class UserSelectListCheckBoxComponent {
    private _selectedUserIds: number[] = [];
    @Input() set selectedUserIds(ids: number[]) {
        this._selectedUserIds = ids;
        if (this._selectedUserIds.includes(this.data.providerId)) {
            this.value = true;
        }
    }

    @Input()
    data: any = {};
    public value: boolean;

    @Output()
    emitter = new Subject<{ action: string; id: number }>();

    constructor() {}

    public ngOnInit() {}

    onCheckboxChange(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        if (isChecked) {
            this.emitter.next({
                action: 'push',
                id: this.data.id,
            });
        } else {
            this.emitter.next({
                action: 'remove',
                id: this.data.id,
            });
        }
    }
}
